import type { GetStaticPaths } from 'next';
import WellHome, { getStaticProps } from '../index';

export { getStaticProps };

export const getStaticPaths: GetStaticPaths = () => {
  if (process.env.TEST) {
    return {
      fallback: 'blocking',
      paths: [],
    };
  }

  return {
    fallback: 'blocking',
    paths: [
      {
        params: {
          pageNum: '2',
        },
      },
    ],
  };
};

export default WellHome;
